module.exports = __webpack_public_path__ + "static/media/onomatopeya.d3ff3806.png";